const ARTWORK_FILTER_KEYS = Object.freeze([
  'artist',
  'gallery',
  'price',
  'size',
  'theme',
  'emotion',
  'medium',
  'color',
  'limitedEditions',
]);

export function resetArtworkSearchFilters(query = {}) {
  const nextQuery = { ...query };

  ARTWORK_FILTER_KEYS.forEach((key) => {
    delete nextQuery[key];
  });

  return nextQuery;
}
